// src/redux/root-reducer.js
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import orderReducer from './order/order.reducer';  // ✅ ADD THIS
import appointmentReducer from './appointment/appointment.reducer'; 


import userReducer from './user/user.reducer';
import cartReducer from './cart/cart.reducer';
import directoryReducer from './directory/directory.reducer';
import shopReducer from './shop/shop.reducer';

// ===== PERSIST CONFIG FOR CART =====
const persistConfig = {
  key: 'cart',
  storage,
  whitelist: ['cartItems'] // Only cart items will be persisted
};

// ===== COMBINE ALL REDUCERS =====
const rootReducer = combineReducers({
  user: userReducer,
  cart: persistReducer(persistConfig, cartReducer),
  directory: directoryReducer,
  shop: shopReducer,
    order: orderReducer,         
  appointment: appointmentReducer 
  
});

export default rootReducer;